'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _store = require('../store');

var _store2 = _interopRequireDefault(_store);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  store: _store2.default,
  data: function data() {
    return {
      commentDialog: false
    };
  },

  props: ['question', 'categoryId', 'questionCommentTooltip', 'questionCommentTitle', 'isSimulation'],
  mounted: function mounted() {},

  computed: _extends({}, (0, _vuex.mapGetters)(['getAssessmentId', 'getActiveCategoryId', 'getQuestionLoading']), {
    answerClass: function answerClass() {
      return {
        'answer--state-invalid': this.question.valid === false,
        'answer--state-true': this.question.answer === 'true',
        'answer--state-false': this.question.answer === 'false',
        'answer--state-null': this.question.answer === undefined || this.question.answer === null || this.question.answer === ''
      };
    }
  }),
  methods: _extends({}, (0, _vuex.mapActions)(['submitQuestion', 'submitQuestionComment']), (0, _vuex.mapMutations)(['toggleAnswers', 'setQuestion', 'setQuestionComment', 'setQuestionLoading']), {
    setAnswer: function setAnswer(value) {

      this.setQuestionLoading({ loading: true });
      var postValues = {
        assessmentId: this.getAssessmentId,
        categoryId: this.getActiveCategoryId,
        questionId: this.question.id,
        answer: value
      };

      var self = this;
      var promise = this.submitQuestion(postValues);

      promise.then(function (response) {
        if (response.data.customData.displayQuestions !== undefined) {

          var payload = {
            displayQuestions: response.data.customData.displayQuestions,
            resultSimulationInfo: response.data.customData.resultSimulationInfo,
            questionResults: response.data.customData.questionResults,
            categoryId: self.categoryId
          };
          self.toggleAnswers(payload);

          self.setQuestionLoading({ loading: false });
        }

        if (response.data.success === true) {
          self.updateQuestion(value);
          self.setQuestionLoading({ loading: false });
        } else if (response.data.success === false) {

          self.setQuestionLoading({ loading: false });
          self.$notify({
            title: 'Update failed',
            message: response.data.flashMessage,
            type: 'error',
            offset: 150
          });
        }
      }).catch(function (error) {

        self.setQuestionLoading({ loading: false });
        if (error.response !== undefined && error.response.status >= 500 || error.message === "Network Error") {
          self.$notify({
            title: 'Update failed',
            message: 'Due to network or server problems, your request could not be processed. Please try again later.',
            type: 'error',
            offset: 150
          });
        }
      });
    },
    updateQuestion: function updateQuestion(value) {

      var payload = {
        questionId: this.question.id,
        answer: value,
        comment: ''
      };

      if (value === null) {
        payload.valid = false;
      } else {
        payload.valid = true;
      }

      this.setQuestion(payload);
    }
  })
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./public/js/components/question-switch.vue
// module id = ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./public/js/components/question-switch.vue
// module chunks = 0